if (!customElements.get('load-more')) {
  class LoadMore extends HTMLElement {
    constructor() {
      super();
      this.handleClick = this.handleClick.bind(this);
    }

    connectedCallback() {
      this.button = this.querySelector('a[role="button"], button');
      this.button?.addEventListener('click', this.handleClick);

      // Auto-trigger the same load once this element scrolls near the
      // viewport, so users don't have to click "Show More" repeatedly.
      // rootMargin fires it a bit early (before it's actually visible)
      // so the next page is ready by the time they reach the bottom.
      this.observer = new IntersectionObserver(
        (entries) => {
          if (entries[0].isIntersecting) {
            this.handleClick();
          }
        },
        { rootMargin: '600px 0px 600px 0px', threshold: 0 }
      );
      this.observer.observe(this);
    }

    disconnectedCallback() {
      this.button?.removeEventListener('click', this.handleClick);
      this.observer?.disconnect();
    }

    async handleClick(e) {
      e?.preventDefault();
      if (this.button?.disabled) return;

      this.observer?.disconnect();
      this.button.disabled = true;
      this.button.querySelectorAll('.svg-wrapper').forEach(span => {
        span.classList.toggle('hidden');
      });

      const nextPageUrl = this.dataset.nextPageUrl;
      const appendTo = this.dataset.appendTo;
      if (!nextPageUrl || !appendTo) return;
      try {
        const response = await fetch(nextPageUrl);
        const html = await response.text();
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const toAppend = doc.querySelector(appendTo);
        const target = document.querySelector(appendTo);
        if (toAppend && target) {
          Array.from(toAppend.children).forEach(child => {
            target.appendChild(child);
          });
        }
        // Replace this <load-more> with the new one from the fetched HTML, if present
        const newLoadMore = doc.querySelector('load-more');
        if (newLoadMore) {
          this.replaceWith(newLoadMore);
        } else {
          this.remove();
        }
      } catch (err) {
        console.error('Load more failed', err);
      }
    }
  }
  customElements.define('load-more', LoadMore);
}